'use client';

import { useEffect, useMemo } from 'react';
import { CommonInner } from '@publishing/components/ui/CommonInner';
import Tab, { useTab } from '@publishing/components/ui/Tab';

import { HUB_EVENTS } from '../data';
import {
  TAB,
  filterSlideEventsForTab,
  filterCardEventsForTab,
  type TabCategory,
} from '../_lib/tabs';
import s from '../page.module.scss';
import { HubEventCardGrid } from './HubEventCardGrid';
import { HubEventTabList } from './HubEventTabList';
import { HubSlideBanner } from './HubSlideBanner';

export default function EventsHubPage() {
  const tabItems = useMemo(
    () => Object.values(TAB).map((text) => ({ text })),
    [],
  );

  return (
    <Tab tabs={tabItems} index={0} type="button" outline>
      <EventsHubContent />
    </Tab>
  );
}

function EventsHubContent() {
  const { activeIndex, tabs, setActiveIndex } = useTab();

  useEffect(() => {
    if (activeIndex >= tabs.length) {
      setActiveIndex(Math.max(0, tabs.length - 1));
    }
  }, [activeIndex, tabs.length, setActiveIndex]);

  const activeTab = (tabs[activeIndex]?.text ?? TAB.ALL) as TabCategory;

  const filteredSlide = useMemo(
    () => filterSlideEventsForTab(HUB_EVENTS, activeTab),
    [activeTab],
  );

  const filteredCards = useMemo(
    () => filterCardEventsForTab(HUB_EVENTS, activeTab),
    [activeTab],
  );

  const isEmpty = filteredSlide.length === 0 && filteredCards.length === 0;

  return (
    <div className={s.wrapper}>
      <HubEventTabList />

      <CommonInner className={s.inner}>
        {isEmpty ? (
          <p className={s.empty_message}>{activeTab}의 이벤트가 없습니다.</p>
        ) : (
          <>
            <HubSlideBanner key={activeTab} events={filteredSlide} />
            <HubEventCardGrid events={filteredCards} />
          </>
        )}
      </CommonInner>
    </div>
  );
}
